import { ResourceProps } from "@refinedev/core";
import { PartitionOutlined } from "@ant-design/icons";

export const segmentsResource: ResourceProps = {
  name: "segments",
  meta: {
    icon: <PartitionOutlined />,
    label: "Сегменты",
    canDelete: true,
    canEdit: true,
    canShow: true,
    canCreate: true,
  },
  list: "/segments",
  create: "/segments/create",
  edit: "/segments/:id/edit",
  show: "/segments/:id",
};

export const segmentUsersResource: ResourceProps = {
  name: "segment-users",
  list: "/segments/:segmentId",
  meta: {
    parent: "segments",
    hide: true,
    canDelete: false,
    canEdit: false,
    canShow: true,
    canCreate: false,
  },
};
